import { SET_DEVICE, SET_FISCAL_YEAR, SET_POPUP_MSG_MODEL } from './types'

const initialState = {
  isDesktop: true,
  fiscalYear: {
    value: null,
    options: [],
    dateRange: { from: null, to: null, min: null, max: null },
  },
  popUpMsgModel: { open: false, message: '' },
}

const appReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_DEVICE:
      return {
        ...state,
        isDesktop: payload,
      }

    case SET_FISCAL_YEAR:
      return {
        ...state,
        fiscalYear: { ...state?.fiscalYear, ...payload },
      }

    case SET_POPUP_MSG_MODEL:
      return {
        ...state,
        popUpMsgModel: { ...payload },
      }

    default:
      return state
  }
}

export default appReducer
